import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import { useState } from 'react';

function AddForm_Modal({ isOpen, setIsAdd, addCourse, id, editCourse, token, name, 
  setName, code, setCode, credit, setCredit, preRequisite, 
setPreRequisite , setOffer={setOffer},offer={offer}  }) {
  const [loading, setLoading] = useState(false);


  const handleNameChange = (e) => setName(e.target.value)
  const handleCodeChange = (e) => setCode(e.target.value)
  const handleCreditChange = (e) => setCredit(e.target.value)
  const handlePreRequisiteChange = (e) => setPreRequisite(e.target.value)


  const onSubmit = async () => {

    if (loading) return;
    setLoading(true)

    const payload = {
      name: name,
      code: code,
      credit: Number(credit),
      offer: offer,
      preRequisite: preRequisite
    }
    let result

    try {

      if (name == '') {
        toast.error('Failed, Course name is empty!')
        return
      }
      if (code == '') {
        toast.error('Failed, code name is empty!')
        return
      }
      if (  credit == '') {
        toast.error('Failed, credit is empty!')
        return
      }
      // if (preRequisite == '') {
      //   toast.error('Failed, Pre-requisite is empty!')
      //   return
      // }
      if (id == -1)
        result = await addCourse(payload, token)
      else
        result = await editCourse(payload, id, token)
      if (result?.status == 200 || result?.status == 201) {
        let msg = id == -1 ? 'Course added successfully' : 'Course edited successfully'
        toast.success(msg)
        // disappear modal
        setIsAdd(false)
      }
    } catch (error) {
      const errmsg = error.response?.data?.message
      if (!errmsg)
        return

      // show error reason as an error toast 
      if (Array.isArray(errmsg)) {

        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element)
          }, 200 * index);
        });
      } else {
        toast.error(errmsg)
      }

    }finally {
      setLoading(false)
    }
  }

  const onchange= (isOffer)=> setOffer(isOffer)
  return (
    <Modal
      show={isOpen}
      // setIsAdd={setIsAdd}
      onHide={
        function () { setIsAdd(false) }
      }
      centered
    >
      <Modal.Header closeButton  >
        <Modal.Title>{id == -1 ? 'Add new course' : 'Edit course'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group onSubmit={onSubmit} >
          <Form.Label>Course name: </Form.Label>
          <Form.Control type="text" onChange={handleNameChange} value={name} placeholder="Enter course name.." />
          <br />
          <Form.Label>Code name: </Form.Label>
          <Form.Control type="text" onChange={handleCodeChange} value={code} placeholder="Enter course code.." />
          <br />
          <Form.Label>Credit: </Form.Label>
          <Form.Control type="text" onChange={handleCreditChange} value={credit} placeholder="Enter course credit.." />
          <br />
          <Form.Label>Pre-requisite name: </Form.Label>
          <Form.Control type="text" onChange={handlePreRequisiteChange} value={preRequisite} placeholder="Enter Pre-requisite course.." />
          <br />
          <Form.Label>Offer: </Form.Label>
          <div  className="mb-3">
          <Form.Check
            inline
            label="Yes"
            name="group1"
            defaultChecked
            type='radio'
            id={true}
            onChange={()=>onchange(true)}
            />
          <Form.Check
            inline
            // disabled
            name="group1"
            label="No"
            type='radio'
            id={false}
            onChange={()=>onchange(false)}
          />
        </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="primary" type="submit" onClick={() => {
          // this.props.isOpen = false;
          // return handleSubmit(name)
          // return;
          onSubmit()
        }}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddForm_Modal;